import { NgModule } from '@angular/core';
import { GlobalService } from './global.service';
import { LoaderService } from './loader.service';
import { IconSettingsService, ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { KendoIconsService } from './kendo-icons.service';
import { CountdownService } from './countdown-service.service';

@NgModule({
  providers: [
    GlobalService,
    CountdownService,
    LoaderService,
    { provide: ICON_SETTINGS, useValue: { type: 'font', size: 'large' } },
    { provide: IconSettingsService, useClass: KendoIconsService },
  ],
})
export class ServicesModule {}
